export default __webpack_public_path__ + "static/media/tabi-life-black.ea1bb51e.svg";